import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
import checker from "./paymentChecker";
import { isIos } from "@/utils/lodash";
import generalUtilsHelper from "@/utils/generalUtils";
import {
  payByIap,
  payByPayPal,
  payByCoins,
  payByCreditCard,
  payBySuperPay
} from "@/api/http/gx/gxPay";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { remoteImg } from "@/plugins/resPlugin";
import Http from "@/api/http/fetch";
import {
  sendEvent,
  superPayResponse,
  sendEventWithParams
} from "@/utils/analytics";
import { updateEventObj } from "@/utils/sendEventUtil";

const actions: ActionTree<any, any> = {
  async [types.PAYMENT_RETRY_AGAIN](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const { receiptData, retryAgain } = payload;
      const { offer, retryParams } = receiptData;
      if (receiptData.pay_way && receiptData.pay_way === "iap") {
        await dispatch(types.PAY_BY_IAP, {
          offer,
          retryParams
        });
      }
      console.log("PAYMENT_RETRY_AGAIN:", payload);
    } catch (error) {
      console.log("PAYMENT_RETRY_AGAIN: ERROR:", error);
      return Promise.reject(error);
    }
  },
  async [types.PAYMENT_NET_ERROR_HANDLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const { error, retryParams, pay_way } = payload;
    if (error.error && error.error.NSLocalizedDescription) {
      //如果是请求超时或者网络失联:
      const { offer, resource, transaction_id } = retryParams;
      const mockData = {
        receipt_data: {
          ...offer,
          offer,
          resource,
          transaction_id,
          transaction_time: new Date().valueOf(),
          pay_way,
          failed: true, //order用来标记失败
          retryParams
        }
      };
      //添加到历史订单：
      commit(types.ADD_FAILED_OFFER, mockData.receipt_data);
      dispatch(types.ROUTER_PUSH, {
        name: "OrderDetail",
        params: {
          routerTransition: "up",
          result: JSON.stringify(mockData),
          comeFromPayMent: true,
          retryAgain: "first",
          orderTime: new Date().getTime()
        }
      });
    }
  },
  async [types.PAYMENT_ERROR_TOAST_HANDLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //支付错误失败的处理:
    let error: any = {};
    if (payload && payload.error) {
      error = payload.error;
    }
    // const { error, typeName, offer } = payload;
    console.log("PAYMENT_ERROR_TOAST_HANDLE error", error);
    EventBus.$emit("toast-hide");
    if (
      error.error &&
      typeof error.error === "string" &&
      error.error.indexOf("ancelled") > -1
    ) {
      //用户取消的
      console.log("用户取消的购买");
    } else if (error.error && typeof error.error === "string") {
      EventBus.$emit("toast-show", {
        type: "warning",
        content: error.error,
        duration: 2000
      });
    } else if (error.error && error.error.NSLocalizedDescription) {
    } else {
      dispatch(types.DIALOG_SHOW, {
        topIcon: remoteImg("/dialog/group5@3x.png"),
        title: "Purchase Failed?",
        midContent: `Oops, the server is not responding. Please try it again later.`,
        buttons: [{ text: "OK" }]
      });
    }
    // return Promise.reject(error);
  },
  async [types.PAY_BY_SUPER_PAY](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const { offer } = payload;
      const resource = GeneralUtilsHelper.getResourceFromOffer(offer);

      let payWay = "";
      if (payload.payWay && payload.payWay === "super_pay") {
        payWay = "super_pay";
      } else {
        payWay = "backup";
      }

      sendEventWithParams("uia_choose_recommend_app_pay", {
        app_type: payWay
      });

      const notShowVipReward = () => {
        return (
          offer.kind.indexOf("coin") > -1 ||
          offer.kind.indexOf("subs") > -1 ||
          offer.kind.indexOf("vip") > -1
        );
      };

      const vipReward = (totalEffect: any) => {
        return generalUtilsHelper.isVip()
          ? notShowVipReward()
            ? 0
            : Math.floor(
                getters[types.GETTER_PRO_EXTRA_PERCENTAGE] * totalEffect * 0.01
              )
          : 0;
      };

      if (isIos()) {
        let targetScheme: any = [];
        let superPayTargetScheme = [];
        let backUpAppTargetScheme = [];
        //super pay
        if (
          getters[types.GETTER_SUPER_PAY_APP_CONFIG] &&
          getters[types.GETTER_SUPER_PAY_APP_CONFIG].appScheme
        ) {
          superPayTargetScheme.push(
            getters[types.GETTER_SUPER_PAY_APP_CONFIG].appScheme
          );
        }
        if (
          getters[types.GETTER_SUPER_PAY_PARAMS] &&
          getters[types.GETTER_SUPER_PAY_PARAMS].super_list
        ) {
          superPayTargetScheme = [
            ...superPayTargetScheme,
            ...getters[types.GETTER_SUPER_PAY_PARAMS].super_list
          ];
        }
        //back up:
        if (
          getters[types.GETTER_BACK_UP_APP_CONFIG] &&
          getters[types.GETTER_BACK_UP_APP_CONFIG].appScheme
        ) {
          backUpAppTargetScheme.push(
            getters[types.GETTER_BACK_UP_APP_CONFIG].appScheme
          );
        }
        if (
          getters[types.GETTER_BACK_UP_APP_PARAMS] &&
          getters[types.GETTER_BACK_UP_APP_PARAMS].super_list
        ) {
          backUpAppTargetScheme = [
            ...backUpAppTargetScheme,
            ...getters[types.GETTER_BACK_UP_APP_PARAMS].super_list
          ];
        }
        console.log("PAY_BY_SUPER_PAY:", {
          superPayTargetScheme,
          backUpAppTargetScheme,
          payWay: payload.payWay
        });
        //整合list:
        if (payWay === "super_pay") {
          //如果传了 super_pay 只能用 super-pay去支付
          targetScheme = [...superPayTargetScheme];
        } else {
          //其他的支付，是下架以后造成的只能用back_up
          targetScheme = [...backUpAppTargetScheme];
        }

        console.log("targetScheme LIST:", targetScheme);

        for (const scheme of targetScheme) {
          const offerInfo = getters[types.GETTER_INFO_BY_OFFER_DATA](offer);

          let totalEffect =
            offerInfo.reward_effect > 0
              ? offerInfo.reward_effect + offerInfo.effect
              : offerInfo.effect;

          if (vipReward(totalEffect) !== 0) {
            console.log("vipReward(totalEffect):", vipReward(totalEffect));
            totalEffect = totalEffect + vipReward(totalEffect);
          }

          const orderInformation = `${totalEffect} ${offerInfo.type_name}`;

          const imageLink = offerInfo.pic_url;

          let iapPrice = offer.iap && offer.iap.price;
          if (
            payWay === "super_pay" &&
            offer.pay_data &&
            offer.pay_data.super_pay
          ) {
            //只有superpay才会取pay_data里面的字段，用于减价
            iapPrice = offer.pay_data.super_pay.price;
          }

          const IapSuperPay: any = await Http.IapSuperPay({
            productId: offer.iap && offer.iap.product_id,
            offerId: offer.offer_id,
            kind: offer.kind,
            iapPrice, //优先取出pay_data中的super_pay
            targetScheme: scheme,
            resource,
            orderInformation,
            imageLink,
            autoRenewable:
              offer.hasOwnProperty("is_no_auto_renew") &&
              !offer.is_no_auto_renew
                ? true
                : false
          });
          console.log("IapSuperPay的结果:", IapSuperPay);
          if (IapSuperPay === "ok") {
            //开启监听事件，监听post offer v3 TODO

            payBySuperPay(offer, resource, payWay);
            return;
          }
        }

        //如果整个循环都没跳转出去,购买失败
        dispatch(types.SUPER_PAY_TOAST_OR_REDIRECT_TOAST, offer);
      } else {
        const IapSuperPayResult: any = await payBySuperPay(
          offer,
          resource,
          payWay
        );
        dispatch(types.SUPER_PAY_RESULT_PROCESS, IapSuperPayResult);
        console.log("IapSuperPay的结果:", IapSuperPayResult);
      }
    } catch (error) {
      dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
        error
      });
      return Promise.reject(error);
    }
  },
  async [types.SUPER_PAY_TOAST_OR_REDIRECT_TOAST](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      EventBus.$emit("toast-hide");
      const offer = payload;
      if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        dispatch(types.SHOW_REDIRECT_SUPER_PAY, "pay_iap");
        return;
      }
      //如果有导量的参数:
      if (
        getters[types.GETTER_SETTING_DATA] &&
        getters[types.GETTER_SETTING_DATA].redirect_app
      ) {
        dispatch(types.SHOW_REDIRECT);
        return;
      }
      //最后只能paypal支付
      dispatch(types.PAY_BY_PAY_PAL, offer);
      return;
    } catch (error) {
      console.log("SUPER_PAY_TOAST_OR_REDIRECT_TOAST error:", error);
    }
  },
  async [types.TAKE_DOWN_SHOW_BACK_UP_TOAST](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const dialogObj: any = {
        title: "New Version Available",
        midContent: `Dear users, we’ve released a new version, for more features and better user experience, please upgrade this app.`,
        buttons: [
          {
            text: "Upgrade Now",
            clickFn: async () => {
              if (payload && payload.type === "back_up") {
                //下载back up
                dispatch(types.START_INSTALL_BACK_UP_APP, {
                  ga: "pay_popup"
                });
              } else {
                //导量下架
                Http.StartNewWebInstance(
                  getters[types.GETTER_HAS_REDIRECT].value
                );
              }
            },
            bgColor: "rgb(0,192, 188)"
          },
          {
            text: "NOT NOW",
            clickFn: () => {}
          }
        ],
        closeImgShow: true,
        topIcon: require("@/assets/icons-file/dialog/picNewversionPopup@2x.png")
      };

      dispatch(types.DIALOG_SHOW, dialogObj);
    } catch (error) {}
  },
  async [types.PAY_BY_IAP]({ state, commit, dispatch, getters }, payload: any) {
    try {
      const { offer, retryParams } = payload;

      const normalIapProcess = async () => {
        try {
          EventBus.$emit("toast-show", {
            type: "loading",
            content: "processing…",
            duration: "infinite"
          });

          let result: any;

          if (retryParams) {
            console.log("PAY_BY_IAP重试retryParams：", retryParams);
            result = await payByIap(
              offer,
              GeneralUtilsHelper.getResourceFromOffer(offer),
              retryParams
            );
          } else {
            console.log("offer", offer);
            result = await payByIap(
              offer,
              GeneralUtilsHelper.getResourceFromOffer(offer)
            );
          }

          EventBus.$emit("toast-hide");

          checker.showRewardIfNeeded({ offer, payWay: "iap" });

          if (result.hasOwnProperty("user_info")) {
            console.log(
              "result.user_info————————————————————",
              result.user_info
            );
            dispatch(types.REFRESH_USERINFO_DATA, result);
            commit(types.UPDATE_PURCHASED_TIME, "iap");
            // dispatch(types.ADD_PURCHASED_VIP_PACKAGE_OFFER, result);
          }

          let routerType = types.ROUTER_PUSH;
          if (retryParams) {
            //如果是重试的替换当前的页面
            routerType = types.ROUTER_REPLACE;
            //删除掉cache的订单
            commit(types.DELETE_FAILED_OFFER, retryParams);
            //刷新order
            EventBus.$emit("retry-order");
          }
          dispatch(routerType, {
            name: "OrderDetail",
            params: {
              routerTransition: "up",
              result: JSON.stringify(result),
              comeFromPayMent: true,
              orderTime: new Date().getTime()
            }
          });

          //如果买的是vip，并且当前的earncoin的offer是vip,需要skip:
          if (
            result.receipt_data.kind &&
            result.receipt_data.kind.indexOf("vip") > -1
          ) {
            EventBus.$emit("skip-vip-feed");
          }
        } catch (error) {
          console.log("normalIapProcess error:", error);
          if (
            error.error &&
            typeof error.error === "string" &&
            (error.error.indexOf("product identifier invalid") > -1 ||
              error.error.indexOf("Invalid product id") > -1)
          ) {
            return Promise.reject({
              error:
                "Service is temporarily unavailable,please try again later."
            });
          }

          return Promise.reject(error);
        }
      };

      const superPayProcess = async (way?: string) => {
        try {
          if (isIos()) {
            // IOS
            //判断iap是否合法，如果合法随他而去：
            const IapProductValid = await Http.IapProductValid(
              offer.iap && offer.iap.product_id
            );
            console.log("IapProductValid:", IapProductValid);
            if (
              IapProductValid === "invalid" ||
              (way && way === "direct_superpay")
            ) {
              //如果不合法或者白名单再走superPay逻辑: ios有自检逻辑，不需要担心：
              //superpay
              dispatch(types.PAY_BY_SUPER_PAY, { offer });
            } else {
              await normalIapProcess();
            }
            //走正常的IAP的逻辑》》》》》
          } else {
            // 安卓:
            //判断superpay的app是否可用:
            const IsSuperPayAvailable = await Http.IsSuperPayAvailable();
            console.log("IsSuperPayAvailable:", IsSuperPayAvailable);
            if (IsSuperPayAvailable === "true") {
              //安卓的ipa购买逻辑
              //superpay
              dispatch(types.PAY_BY_SUPER_PAY, { offer });
            } else {
              dispatch(types.SUPER_PAY_TOAST_OR_REDIRECT_TOAST, offer);
            }
          }
        } catch (error) {
          return Promise.reject(error);
        }
      };

      // // 校验当前offer_id的有效性
      // const product_id = offer && offer.iap && offer.iap.product_id;
      // const iap_valid = product_id
      //   ? getters[types.GETTER_PRODUCTID_VALID](product_id)
      //   : true;
      const checkSuperPayWayInterfaceEnable = await dispatch(
        types.CHECK_SUPER_PAY_WAY_CAN_USE
      );

      console.log(
        "checkSuperPayWayInterfaceEnable",
        checkSuperPayWayInterfaceEnable
      );

      //super pay的白名单逻辑:
      if (
        getters[types.GETTER_SUPER_PAY_PARAMS] &&
        getters[types.GETTER_SUPER_PAY_PARAMS].test_user_list &&
        checkSuperPayWayInterfaceEnable &&
        getters[types.GETTER_SUPER_PAY_PARAMS].test_user_list.includes(
          getters[types.GETTER_MASTER_ID]
        )
      ) {
        //直接走superpay的逻辑:
        console.log("通过白名单直接走superpay的逻辑:");
        await superPayProcess("direct_superpay");
      } else if (getters[types.GETTER_APP_TAKE_DOWN]) {
        //如果被下架了:

        if (checkSuperPayWayInterfaceEnable) {
          //superPay相关的接口都可以用的情况下：
          await superPayProcess();
        } else {
          //如果superpay的接口不能用:,弹导量下载：
          dispatch(types.TAKE_DOWN_SHOW_BACK_UP_TOAST);
        }
      } else {
        console.log("走的正常的normalIapProcess");
        await normalIapProcess();
      }
    } catch (error) {
      console.log("PAY_BY_IAP error:", error);
      // 清空购买的打点对象
      updateEventObj(null);
      dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
        error
      });
      return Promise.reject(error);
    }
  },
  async [types.PAY_BY_PAY_PAL](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "processing…",
        duration: "infinite"
      });
      console.log("PAY_BY_PAY_PAL payload:", payload);
      const offer = payload;
      const result: any = await payByPayPal(
        offer,
        GeneralUtilsHelper.getResourceFromOffer(offer)
      );
      EventBus.$emit("toast-hide");

      checker.showRewardIfNeeded({ offer, payWay: "paypal" });
      console.log("PAY_BY_PAY_PAL result:", result);
      if (result.data && result.data.hasOwnProperty("user_info")) {
        //paypal返回的格式特立独行，需要把data转到外层结构去：
        result.user_info = result.data.user_info;
      }
      if (result.resource) {
        result.receipt_data.resource = result.resource;
        //paypal返回的格式特立独行，需要把data转到外层结构去：
      }
      dispatch(types.REFRESH_USERINFO_DATA, result);
      commit(types.UPDATE_PURCHASED_TIME, "paypal");
      dispatch(types.ROUTER_PUSH, {
        name: "OrderDetail",
        params: {
          routerTransition: "up",
          result: JSON.stringify(result),
          comeFromPayMent: true,
          orderTime: new Date().getTime()
        }
      });
      //如果买的是vip，并且当前的earncoin的offer是vip,需要skip:
      if (
        result.receipt_data.kind &&
        result.receipt_data.kind.indexOf("vip") > -1
      ) {
        EventBus.$emit("skip-vip-feed");
      }
      console.log("PAY_BY_PAY_PAL result", result);
    } catch (error) {
      // 清空购买的打点对象
      updateEventObj(null);
      //购买失败
      dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
        error
      });
      return Promise.reject(error);
    }
  },
  async [types.SUPER_PAY_RESULT_PROCESS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    EventBus.$emit("toast-hide");
    const result = payload;
    result.receipt_data = {
      resource: result.resource,
      ...result.offer_data,
      transaction_id: result.transaction_id,
      transaction_time: result.transaction_time
    };

    //如果是订阅的需要拉取service_list:
    if (generalUtilsHelper.isSubsOffer(result.offer_data)) {
      dispatch(types.UPDATE_GX_SERVICE_LIST);
    }

    checker.showRewardIfNeeded({ offer: result.offer_data, payWay: "iap" });

    dispatch(types.UPDATE_GX_MASTER_SERVER_DATA);

    if (result.hasOwnProperty("actual_effect")) {
      result.receipt_data.effect = result.actual_effect;
    }

    if (result.hasOwnProperty("pay_way")) {
      result.receipt_data.pay_way = result.pay_way;
    }

    dispatch(types.ADD_PURCHASED_OFFER, result.receipt_data);
    commit(types.UPDATE_PURCHASED_TIME, "iap");

    dispatch(types.ROUTER_PUSH, {
      name: "OrderDetail",
      params: {
        routerTransition: "up",
        result: JSON.stringify(result),
        comeFromPayMent: true,
        orderTime: new Date().getTime()
      }
    });
  },
  async [types.REFRESH_USERINFO_DATA](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const userId = getters[types.GETTER_DEVICE_ID];
    // 这里有个坑，后台在订阅的user_info返回值的service列表会有问题，所以需要判断
    if (
      payload.user_info &&
      payload.user_info.user_id &&
      payload.user_info.user_id === userId
    ) {
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, payload.user_info);
    } else {
      dispatch(types.UPDATE_GX_SERVICE_LIST);
    }
    dispatch(types.ADD_PURCHASED_OFFER, payload.receipt_data);
  },
  async [types.PAY_BY_CREDIT_CARD](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "processing…",
        duration: "infinite"
      });
      let offer: any;
      let result: any;
      if (isIos()) {
        offer = payload;
        result = await payByCreditCard(
          offer,
          GeneralUtilsHelper.getResourceFromOffer(offer)
        );
      } else {
        offer = payload.offer;
        result = await payByCreditCard(
          payload,
          GeneralUtilsHelper.getResourceFromOffer(offer)
        );
        console.log(result);
      }
      EventBus.$emit("toast-hide");

      checker.showRewardIfNeeded({ offer, payWay: "card" });

      if (result.data && result.data.hasOwnProperty("user_info")) {
        //stripe返回的格式特立独行，需要把data转到外层结构去：
        result.user_info = result.data.user_info;
      }
      // result.user_info.coins = result.user_info.coins + result.user_info.coins_to_add;
      // dispatch(types.REFRESH_USERINFO_DATA, result);
      // dispatch(types.ADD_PURCHASED_VIP_PACKAGE_OFFER, result);
      dispatch(types.UPDATE_GX_MASTER_SERVER_DATA);
      commit(types.UPDATE_PURCHASED_TIME, "card");
      dispatch(types.ROUTER_PUSH, {
        name: "OrderDetail",
        params: {
          routerTransition: "up",
          result: JSON.stringify(result),
          comeFromPayMent: true,
          orderTime: new Date().getTime()
        }
      });
    } catch (error) {
      // 清空购买的打点对象
      updateEventObj(null);
      //购买失败
      console.log("PAY_BY_CREDIT_CARD error:", error);
      dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
        error
      });
      return Promise.reject(error);
    }
  },
  async [types.PAY_BY_COIN](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      console.log("PAY_BY_COIN:", payload);
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "processing…",
        duration: "infinite"
      });
      const offer = payload;
      const result: any = await payByCoins(
        offer,
        GeneralUtilsHelper.getResourceFromOffer(offer)
      );
      EventBus.$emit("toast-hide");

      checker.showRewardIfNeeded({ offer, payWay: "coin" });

      console.log("PAY_BY_COIN result:", result);
      if (result.hasOwnProperty("user_info")) {
        dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result.user_info);
        commit(types.UPDATE_PURCHASED_TIME, "coin");
        // 由于后台返回的缺陷，处理一次receipt_data中的effect
        const actual_effect =
          (result.data && result.data.final_effect) ||
          result.receipt_data.actual_effect;
        if (actual_effect) {
          result.receipt_data.effect = actual_effect;
        }
        dispatch(types.ADD_PURCHASED_OFFER, result.receipt_data);
        // dispatch(types.ADD_PURCHASED_VIP_PACKAGE_OFFER, result);
      }
      dispatch(types.ROUTER_PUSH, {
        name: "OrderDetail",
        params: {
          routerTransition: "up",
          result: JSON.stringify(result),
          comeFromPayMent: true,
          orderTime: new Date().getTime()
        }
      });

      console.log("PAY_BY_COIN result", result);
    } catch (error) {
      console.log("PAY_BY_COIN  err:", error);
      // 清空购买的打点对象
      updateEventObj(null);
      //购买失败
      EventBus.$emit("toast-hide");
      dispatch(types.DIALOG_SHOW, {
        topIcon: remoteImg("/dialog/group5@3x.png"),
        title: "Purchase Failed?",
        midContent: `Oops, the server is not responding. Please try it again later.`,
        buttons: [{ text: "OK" }]
      });
      return Promise.reject(error);
    }
  },
  async [types.PAY_BY_ANY]({ state, commit, dispatch, getters }, payload: any) {
    try {
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "processing…",
        duration: "infinite"
      });
      const { offer, payWay } = payload;
      console.log("PAY_BY_ANY payload:", {
        offer,
        payWay
      });
      //先进入购买的判断：
      const result = await checker.check(offer);
      console.log("checker检查的结果:", result);
      if (!result) {
        //没有通过检测:
        EventBus.$emit("toast-hide");
        return Promise.reject(new Error("Payment failure"));
      }

      if (offer.way === "coin") {
        dispatch(types.PAY_BY_COIN, offer);
      } else {
        EventBus.$emit("toast-hide");

        const enter_payment = await dispatch(
          types.JUDGE_CAN_ENTER_PAYMENT,
          offer
        );
        const { canShowStripe, canShowPayPal } = enter_payment;
        console.log("enter_payment", enter_payment);
        const canShowSuperPay = getters[
          types.GETTER_SUPER_PAY_PAYMENT_SHOW_ENABLE
        ](offer);
        if (canShowStripe || canShowPayPal || canShowSuperPay) {
          dispatch(types.ROUTER_PUSH, {
            name: "Payment",
            params: {
              routerTransition: "up"
            },
            query: {
              offer: JSON.stringify(offer)
            }
          });
        } else {
          await dispatch(types.PAY_BY_IAP, { offer });
        }
      }
    } catch (error) {
      //购买失败
      console.log("PAY_BY_ANY error:", error);
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_PAYMENT_SWITCH_THRESHOLD](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      if (getters[types.GETTER_PAYMENT_SWITCH_THRESHOLD] === null) {
        //生成一个0-100的随机数，更新到state:
        const randomNum = Math.floor(Math.random() * 100);
        commit(types.UPDATE_PAYMENT_SWITCH_THRESHOLD, randomNum);
      }
    } catch (error) {
      //更新失败
      return Promise.reject(error);
    }
  },
  async [types.ADD_PURCHASED_OFFER](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const offer = payload;
    if (offer.kind === "special_follow" || offer.kind === "special_like") {
      console.log("购买了special_offer", offer);
      commit(types.UPDATE_LAST_SPECIAL_PURCHASED, payload);
    }
    if (
      offer.kind === "feed_coin" ||
      offer.kind === "feed_lucky_coin" ||
      offer.kind === "lucky_coin"
    ) {
      //如果是购买的feed_coins自动skip
      dispatch(types.SKIP_FEED);
    }
    commit(types.ADD_PURCHASED_OFFER, payload);
    // setTimeout(() => {
    //   EventBus.$emit("show-delivered-dialog", payload);
    // }, 3000);
  },
  async [types.JUDGE_CAN_ENTER_PAYMENT](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    // app启动次数
    const appLaunchTime = getters[types.GETTER_APP_LAUNCH_TIME];

    //各个支付项目的支付次数
    const iapPurchasedTime = getters[types.GETTER_PURCHASED_TIME]("iap");
    const paypalPurchasedTime = getters[types.GETTER_PURCHASED_TIME]("paypal");
    const cardPurchasedTime = getters[types.GETTER_PURCHASED_TIME]("card");

    const purchaseSum =
      iapPurchasedTime + paypalPurchasedTime + cardPurchasedTime;

    // 获取其他支付条件是否被禁用
    const {
      paypal_enabled,
      stripe_enabled
    } = GeneralUtilsHelper.paymentSwitch();
    console.log(
      "paypal_enabled, stripe_enabled",
      paypal_enabled,
      stripe_enabled
    );

    // 首次进入app的时间戳
    const first_enter_timestamp = getters[types.GETTER_FIRST_ENTER_TIMESTAMP];

    // 获取满足其他支付条件的配置
    const { paypal, stripe } = getters[types.GETTER_FEATURES_ITEM_BY_FUNCTION](
      payload
    );
    console.log("paypal, stripe", paypal, stripe);

    const isSub = GeneralUtilsHelper.isSubsOffer(payload);

    // 判断某种类型是否达到可用限制
    const judgeMethodCanUse = (type: any) => {
      const { is_enabled, delay } = type;
      if (!is_enabled) {
        return false;
      }
      const or_open_app = type.event.find((event: any) => {
        return event.eventName === "or_open_app";
      });
      const open_app = type.event.find((event: any) => {
        return event.eventName === "open_app";
      });
      const pay_by_iap = type.event.find((event: any) => {
        return event.eventName === "pay_by_iap";
      });
      const pay_by_cash = type.event.find((event: any) => {
        return event.eventName === "pay_by_cash";
      });
      const delay_action =
        new Date().getTime() - first_enter_timestamp > delay * 1000;
      console.log({
        or_open_app,
        open_app,
        pay_by_iap,
        appLaunchTime,
        iapPurchasedTime,
        delay_action,
        purchaseSum
      });
      const judge_or_open_app =
        !or_open_app || (or_open_app && appLaunchTime >= or_open_app.count);
      const judge_open_app =
        !open_app || (open_app && appLaunchTime >= open_app.count);
      const judge_pay_by_iap =
        !pay_by_iap || (pay_by_iap && iapPurchasedTime >= pay_by_iap.count);
      const judge_pay_by_cash =
        !pay_by_cash || (pay_by_cash && purchaseSum >= pay_by_cash.count);
      return (
        is_enabled &&
        delay_action &&
        (judge_or_open_app ||
          (judge_open_app && judge_pay_by_iap && judge_pay_by_cash))
      );
    };
    const canShowStripe: boolean =
      !isSub && stripe_enabled && judgeMethodCanUse(stripe);
    const canShowPayPal: boolean = paypal_enabled && judgeMethodCanUse(paypal);
    console.log("canShowStripe, canShowPayPal", canShowStripe, canShowPayPal);
    return { canShowStripe, canShowPayPal };
  }
};

export default actions;
